"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isEnterOrSpace = function isEnterOrSpace(_ref) {
  var key = _ref.key;
  return key === 'Enter' || key === ' ';
};

var _default = isEnterOrSpace;
exports["default"] = _default;